import {httpClient} from "@/Repositories/Reports/HttpClient";
import _ from "lodash";

export default {

    /**
     * Search data sources matching given criteria
     *
     * @param searchArguments
     * @returns {Promise<*>}
     */
    async searchDataSources(searchArguments) {
        let criteria = {
            filters: _.cloneDeep(searchArguments),
        }
        return httpClient.get(route('reports.data-sources.search', criteria));
    },

    /**
     * Search report configuration matching given criteria
     *
     * @param searchArguments
     * @returns {Promise<*>}
     */
    async searchReportConfiguration(searchArguments) {
        let criteria = {
            filters: _.cloneDeep(searchArguments),
        }
        return httpClient.get(route('reports.configuration.search', criteria));
    },

    /**
     *
     * @returns {[{id: string},{id: string},{id: string},{id: string},{id: string},null]}
     */
    getStatuses() {
        return [
            {id: 'IN_PROCESS'},
            {id: 'GENERATED'},
            {id: 'IN_REVIEW'},
            {id: 'DEPRECATED'},
            {id: 'FAILED'},
            {id: 'CLOSED'},
        ];
    },
}
